import { render, staticRenderFns } from "./iconData.vue?vue&type=template&id=8ed79ac2&scoped=true"
import script from "./iconData.vue?vue&type=script&lang=js"
export * from "./iconData.vue?vue&type=script&lang=js"
import style0 from "./iconData.vue?vue&type=style&index=0&id=8ed79ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed79ac2",
  null
  
)

export default component.exports